import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export function StepAssetsStartDateHelp() {
  const { t } = useTranslation('maintenance');

  return (
    <aside
      className="inline-info-note"
      aria-label={t('wizard.assets.startDateHelp.title')}
      style={{
        width: 'fit-content',
        maxWidth: '26rem',
        flexShrink: 1,
        marginLeft: 'auto',
      }}
    >
      <InfoCircleOutlined className="inline-info-note__icon" aria-hidden />
      <div className="inline-info-note__body">
        <p className="inline-info-note__lead">
          <span className="inline-info-note__label">
            {t('wizard.assets.startDateHelp.title')}
          </span>
          <span className="inline-info-note__sep" aria-hidden>
            ·
          </span>
          <span>{t('wizard.assets.startDateHelp.line1')}</span>
        </p>
        <p className="inline-info-note__meta">
          {t('wizard.assets.startDateHelp.line2')}
        </p>
      </div>
    </aside>
  );
}
